import { cx } from '@emotion/css'
import {
    CardEvents,
    CollectionEvent,
    createCardClickedEvent,
    PublicationCardItem,
    toLinkWithHint,
    useFeature,
} from '@news-mono/web-common'
import { MaybeLoaded } from 'json-react-layouts-data-loader'
import React from 'react'
import { invertMaybeLoadedItems } from '../../../../collections/helpers/loading'
import { getFundingType } from '../../../../templates/Publication/lib/get-funding-type'
import {
    StyledEntertainmentCard,
    StyledEntertainmentCardIcon,
    StyledEntertainmentCardText,
    StyledEntertainmentInlineCardContainer,
} from './SevenEntertainmentInlineRelatedContentCard.styled'

const cardArrow = require('./assets/SevenEntertainmentInlineCardArrow.svg')

interface SevenNewsInlineRelatedContentCardProps {
    items: MaybeLoaded<PublicationCardItem[]>
    expectedCards: number
    onEvent: (event: CardEvents | CollectionEvent) => void
}
export const SevenEntertainmentInlineRelatedContentCards: React.FC<SevenNewsInlineRelatedContentCardProps> =
    (props) => {
        const items = invertMaybeLoadedItems(props.items, props.expectedCards)
        const layout = props.expectedCards >= 2 ? 'portrait' : 'landscape'

        const storyClassification = useFeature('story-classification')

        function linkClicked(
            e: React.MouseEvent<HTMLElement>,
            item: MaybeLoaded<PublicationCardItem>,
            cardNumber: number,
        ) {
            if (!item.loaded) {
                e.preventDefault()
                return
            }
            props.onEvent(
                createCardClickedEvent(
                    item.result,
                    'SevenNewsInlineRelatedContentCard',
                    'InlineRelatedContent',
                    cardNumber,
                    getFundingType(item.result, storyClassification),
                    'InlineRelatedCollection',
                ),
            )
        }

        return (
            <StyledEntertainmentInlineCardContainer
                layout={layout}
                className={cx('hide-print')}
            >
                {items.map((item, index) => {
                    const key = (item.loaded && item.result.id) || index

                    return (
                        <StyledEntertainmentCard
                            to={toLinkWithHint(item)}
                            layout={layout}
                            onClick={(event) => {
                                linkClicked(event, item, index)
                            }}
                            key={key}
                        >
                            <StyledEntertainmentCardText
                                item={item}
                                kickerMode={'hidden'}
                                teaserMode={'hidden'}
                                onEvent={props.onEvent}
                                innerRef={undefined}
                                fontScale={0.83}
                                hasPadding={true}
                            />
                            <StyledEntertainmentCardIcon
                                src={cardArrow}
                                alt="Arrow icon"
                            />
                        </StyledEntertainmentCard>
                    )
                })}
            </StyledEntertainmentInlineCardContainer>
        )
    }
